import {
  bestPriceGuaranteeUrl,
  contactUrl,
  cookiePolicyUrl,
  flysiteUrl,
  privacyUrl,
  recurringTermsUrl,
  supportUrl,
  termsUrl,
} from 'utils/flysiteUrls/flysiteUrls';
import type { SupportedLocalesKeys } from 'utils/translations/translations';

export type FlysiteUrls = ReturnType<typeof useFlysiteUrls>;

export const useFlysiteUrls = (locale: SupportedLocalesKeys) => {
  const urls = {
    bestPriceGuaranteeUrl: bestPriceGuaranteeUrl(locale),
    contactUrl: contactUrl(locale),
    cookiePolicyUrl: cookiePolicyUrl(locale),
    flysiteUrl: flysiteUrl(locale),
    privacyUrl: privacyUrl(locale),
    recurringTermsUrl: recurringTermsUrl(locale),
    supportUrl: supportUrl(locale),
    termsUrl: termsUrl(locale),
  };

  return urls;
};
